/**
 * @file コンポーネント：フル動画ページヘッダー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Accountmenu } from "~/src/components/projects/Accountmenu";
import { Loginmenu } from "~/src/components/projects/Loginmenu";
import { ModalLogin } from "~/src/components/projects/ModalLogin";
import { ModalLogout } from "~/src/components/projects/ModalLogout";
import { ModalNewPassword } from "~/src/components/projects/ModalNewPassword";
import { ContentsMenu } from "~/src/components/projects/Video/ContentsMenu";
import { Sidemenu } from "~/src/components/projects/Sidemenu";
import { SelectLanguage } from "~/src/components/projects/Video/SelectLanguage";

// 関数読み込み
import {
    fnGetDepartmentName,
    fnGetDepartmentPathname,
} from "~/src/functions/common";

// スタイル読み込み
import {
    StyledHeader,
    StyledHeaderNavigation,
    StyledHeaderNavigationLogo,
    StyledHeaderNavigationLogoAnchor,
    StyledHeaderNavigationLogoImage,
    HeaderRight,
    StyledHeaderButtonMenu,
    StyledHeaderButtonMenuAnchor,
    StyledHeaderButtonMenuIcon,
    StyledHeaderButtonMenuText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            <StyledHeader>
                <StyledHeaderNavigation>
                    {/* サイトロゴ */}
                    <StyledHeaderNavigationLogo>
                        <StyledHeaderNavigationLogoAnchor
                            href={fnGetDepartmentPathname()}
                        >
                            <StyledHeaderNavigationLogoImage
                                alt={
                                    localized["Title.Home"] +
                                    " " +
                                    fnGetDepartmentName()
                                }
                                height="18"
                                src="/assets/images/logo.png"
                                width="90"
                            />
                        </StyledHeaderNavigationLogoAnchor>
                    </StyledHeaderNavigationLogo>
                </StyledHeaderNavigation>
                <HeaderRight>
                    {/* 症例データの言語 */}
                    <SelectLanguage
                        languageCodeOperation={
                            props.languageCodeOperation
                        }
                        listLanguage={props.listLanguage}
                    />
                    {/* ログインメニュー */}
                    <Loginmenu
                        isLogin={props.isLogin}
                        isIdentificationUser={props.isIdentificationUser}
                        isSponsorUser={props.isSponsorUser}
                        refButtonAccount={props.refButtonAccount}
                        setIsOpenAccountmenu={props.setIsOpenAccountmenu}
                        setIsOpenModalLogin={props.setIsOpenModalLogin}
                        setIsOpenModalLogout={props.setIsOpenModalLogout}
                    />
                </HeaderRight>
                {props.isSponsorUser === false && (
                    // スポンサーユーザー以外の場合のみ表示
                    <>
                        {/* サイドメニューボタン */}
                        {props.isOpenSidemenu === true ? (
                            // メニューリストが開いている
                            <StyledHeaderButtonMenu
                                onClick={() =>
                                    props.setIsOpenSidemenu(
                                        !props.isOpenSidemenu
                                    )
                                }
                                type="button"
                            >
                                <StyledHeaderButtonMenuAnchor>
                                    <StyledHeaderButtonMenuIcon>
                                        <i className="fas fa-times"></i>
                                    </StyledHeaderButtonMenuIcon>
                                    <StyledHeaderButtonMenuText>
                                        {localized["Label.Menu"]}
                                    </StyledHeaderButtonMenuText>
                                </StyledHeaderButtonMenuAnchor>
                            </StyledHeaderButtonMenu>
                        ) : (
                            // メニューボタンが閉じている
                            <StyledHeaderButtonMenu
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.setIsOpenSidemenu(
                                        !props.isOpenSidemenu
                                    );
                                }}
                                type="button"
                            >
                                <StyledHeaderButtonMenuAnchor>
                                    <StyledHeaderButtonMenuIcon>
                                        <i className="fas fa-bars"></i>
                                    </StyledHeaderButtonMenuIcon>
                                    <StyledHeaderButtonMenuText>
                                        {localized["Label.Menu"]}
                                    </StyledHeaderButtonMenuText>
                                </StyledHeaderButtonMenuAnchor>
                            </StyledHeaderButtonMenu>
                        )}
                        {/* サイドメニュー */}
                        <Sidemenu
                            departmentlist={props.departmentlist}
                            isOpenSidemenu={props.isOpenSidemenu}
                            isVideo={false}
                        />
                    </>
                )}
            </StyledHeader>
            {/* コンテンツメニュー */}
            <ContentsMenu
                setIsOpenModalLogin={props.setIsOpenModalLogin}
                adOperationSummary={props.adOperationSummary}
                hasDigest={props.hasDigest}
                hasPointcontents={props.hasPointcontents}
                hasPostoperation={props.hasPostoperation}
                hasPreoperation={props.hasPreoperation}
                isEditPage={props.isEditPage}
                isPaid={props.isPaid}
                isPurchased={props.isPurchased}
                listSurgicalEquipment={props.listSurgicalEquipment}
                refContentsMenu={props.refContentsMenu}
                selectedContentsData={props.selectedContentsData}
                setIsHighlightPopupPayment={props.setIsHighlightPopupPayment}
                setSelectedContentsData={props.setSelectedContentsData}
                summary={props.summary}
            />
            {/* アカウントメニュー */}
            <Accountmenu
                isNotificationAccount={props.isNotificationAccount}
                isOpenAccountmenu={props.isOpenAccountmenu}
                isSponsorUser={props.isSponsorUser}
                refAccountmenu={props.refAccountmenu}
                setIsOpenAccountmenu={props.setIsOpenAccountmenu}
                setIsOpenModalLogout={props.setIsOpenModalLogout}
            />
            {/* ログインモーダル */}
            {props.isOpenModalLogin === true && (
                <ModalLogin
                    loginErrorMessages={props.loginErrorMessages}
                    isOpenModalLogin={props.isOpenModalLogin}
                    redirectUrl={props.redirectUrl}
                    setEmail={props.setEmail}
                    setIsOpenModalLogin={props.setIsOpenModalLogin}
                    setIsOpenModalNewPassword={props.setIsOpenModalNewPassword}
                    setLoginErrorMessages={props.setLoginErrorMessages}
                    setPassword={props.setPassword}
                />
            )}
            {/* ログアウトモーダル */}
            {props.isOpenModalLogout === true && (
                <ModalLogout
                    isOpenModalLogout={props.isOpenModalLogout}
                    setIsOpenModalLogout={props.setIsOpenModalLogout}
                />
            )}
            {/* パスワード変更モーダル */}
            {props.isOpenModalNewPassword === true && (
                <ModalNewPassword
                    email={props.email}
                    isOpenModalNewPassword={props.isOpenModalNewPassword}
                    oldPassword={props.password}
                    redirectUrl={props.redirectUrl}
                    setIsOpenModalLogin={props.setIsOpenModalLogin}
                    setIsOpenModalNewPassword={props.setIsOpenModalNewPassword}
                    setLoginErrorMessages={props.setLoginErrorMessages}
                />
            )}
        </>
    );
};
